export const toggleSetMembership = (ids: Set<string>, id: string): Set<string> => {
    const next = new Set(ids);
    if (next.has(id)) {
        next.delete(id);
    } else {
        next.add(id);
    }

    return next;
};
